import { FileElement, FileType } from '@otp/ui';
import { FileAsset, FileAssetType, Maybe } from 'src/graphql/generated/graphql';
import { capitalize } from 'src/utils/string';

export const mapFileAssetsToForm = (
  fileAssets?: FileAsset[] | Maybe<FileAsset[]>,
) =>
  fileAssets?.map((fileAsset) => ({
    id: fileAsset.id,
    title: fileAsset.title as string,
    type: fileAsset.type?.toLowerCase() as unknown as FileType,
    url: fileAsset.url,
    readonly: !!fileAsset.isParentAsset,
  })) || [];

export const mapFileAssetsToRequest = (fileAssets: FileElement[]) => {
  return fileAssets
    .filter((file) => !file.readonly)
    .map((file) => ({
      id: file.id as string,
      key: (file.id || file.key) as string,
      title: file.title,
      type: capitalize(file.type) as FileAssetType,
    }));
};
